import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initSubscribeForm() {
    const $subscribeFormContainer = document.querySelectorAll<HTMLFormElement>('.js-form-subscribe');
    $subscribeFormContainer.forEach($container => {
        new SubscribeForm($container);
    });
}

export class SubscribeForm {
    $container: HTMLFormElement;
    stripe: stripe.Stripe|null = null;
    stripePaymentElements: stripe.elements.Elements|null = null;
    $cartLinesContainer: HTMLUListElement;
    $cartTotalContainer: HTMLElement;
    $amount: number | null = null;
    
    // afficher l'abo supplementaire et afficher l'addresse de facturation
    constructor($container: HTMLFormElement) {
        this.$container = $container;
        this.$cartLinesContainer = document.querySelector('[data-cart-lines]') as HTMLUListElement;
        this.$amount = this.$cartLinesContainer?.dataset.amountAbo ? parseInt(this.$cartLinesContainer?.dataset.amountAbo) : null;
        this.$cartTotalContainer = document.querySelector('[data-cart-total]') as HTMLElement;
        this.init();
    }

    init(): void {
        const handleOtherBillingAddres = () => {
            const otherBillingAddresSwitchYes = this.$container.querySelector('#form_subscribe_different_invoice_address_0') as HTMLInputElement;
            const otherBillingAddresSwitchNo = this.$container.querySelector('#form_subscribe_different_invoice_address_1') as HTMLInputElement;
            const otherBillingAddressFields = this.$container.querySelector('.js-form-row-billing-fields');
            const otherBillingAddressInputs = otherBillingAddressFields?.querySelectorAll('input');

            otherBillingAddresSwitchYes?.addEventListener('change', () => {
                if (otherBillingAddresSwitchYes.checked) {
                    otherBillingAddressFields?.classList.remove('form-row---hidden');
                    otherBillingAddressInputs?.forEach(input => {
                        if (input.getAttribute('data-required') == '1') {
                            input.required = true;
                            input.value='';
                            input.disabled = false;
                        }
                    });
                }
            })

            otherBillingAddresSwitchNo?.addEventListener('change', () => {
                if (otherBillingAddresSwitchNo.checked) {
                    otherBillingAddressFields?.classList.add('form-row---hidden');
                    otherBillingAddressInputs?.forEach(input => {
                        if (input.getAttribute('data-required') == '1') {
                            input.required = false;
                            input.value='';
                            input.disabled = true;
                        }
                    });
                }
            })

            document.addEventListener('DOMContentLoaded', () => {
                if (otherBillingAddresSwitchYes.checked) {
                    otherBillingAddressFields?.classList.remove('form-row---hidden');
                    otherBillingAddressInputs?.forEach(input => {
                        if (input.getAttribute('data-required') == '1') {
                            input.required = true;
                        }
                    });
                }

                if (otherBillingAddresSwitchNo.checked) {
                    otherBillingAddressFields?.classList.add('form-row---hidden');
                    otherBillingAddressInputs?.forEach(input => {
                        if (input.getAttribute('data-required') == '1') {
                            input.required = false;
                        }
                    });
                }
            })

            this.$container.addEventListener('submit', () => {
                if (otherBillingAddresSwitchNo.checked) {
                    otherBillingAddressInputs?.forEach(input => input.value = '');
                }
            })
        };

        const handleOtherSubscription = () => {
            const addSubscriptionButton = this.$container.querySelector('.js-subscribe-form-add-subscription');
            const otherSubscription = this.$container.querySelector('.js-form-row-new-subscription-fields.form-row---hidden');
            
            addSubscriptionButton?.addEventListener('click', () => {
                const otherSubscriptionCloned = otherSubscription?.cloneNode(true) as HTMLDivElement;
                otherSubscriptionCloned.classList.remove('form-row---hidden');
                otherSubscriptionCloned.classList.add('cloned');
                otherSubscriptionCloned.querySelectorAll('input').forEach(input => {
                    input.disabled = false;
                });

                otherSubscriptionCloned.querySelector('.js-subscribe-form-remove-subscription')?.addEventListener('click', () => {
                    otherSubscriptionCloned.remove();
                    this.updateCart();
                })
                const parentElement = otherSubscription?.parentElement;

                if (parentElement) {
                    parentElement.insertBefore(otherSubscriptionCloned, otherSubscription.nextSibling);
                }

                this.updateCart();
            });

        }

        handleOtherBillingAddres();
        handleOtherSubscription();
        
        this.updateCart();

        // Lorsqu'on submit le formulaire
        this.$container.addEventListener('submit', evt => {
            evt.preventDefault();
            
            this.$container.classList.add('loading');
            
            const formDataValidation = new URLSearchParams();
            formDataValidation.append('action', 'validate_subscribe_form');
        
            for (const pair of new FormData(this.$container)) {
                formDataValidation.append(pair[0], pair[1] as string);
            }

            // Validation ajax
            postData(script_var.ajax_url, formDataValidation).then(response => {
                if (response.success) {
                    const payment_method = this.$container.querySelector('input[name="form_subscribe[payment_method]"]:checked') as HTMLInputElement;
                    if ('stripe' === payment_method.value) {
                        this.stripePayment();
                    } else {
                        this.offlinePayment();
                    }
                    
                } else {
                    this.$container.classList.remove('loading');
                    this.resetErrors();
                    const errors = response.data.errors;
                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) { // Vérifie que la clé appartient bien à l'objet
                            const value = errors[key];
                            if (Array.isArray(value)) {
                                value.forEach((item, index) => {
                                    const fields = this.$container.querySelectorAll(`[name="form_subscribe[${key}][]"]:not([disabled])`);
                                    fields.forEach((field, index) => {
                                        const errorField = field.closest('.form-col')?.querySelector('.form-error[role="alert"]') as HTMLElement;
                                        
                                        if (errorField && value[index]) {
                                          this.displayError(errorField, value[index]);
                                        }
                                      });
                                  });
                            } else {
                                const field = this.$container.querySelector('[name=form_subscribe\\[' + key + '\\]]');
                                if (field) {
                                    const errorField = field.closest('.form-col')?.querySelector('.form-error[role="alert"]') as HTMLElement;
                                    this.displayError(errorField, value);
                                }
                            }
                        }
                    }
                    
                    const navHeight = document.getElementById('main-header')?.offsetHeight;
                    const elements = document.querySelectorAll('div.form-error');
                    const firstError = Array.from(elements).find(element => element.textContent.trim() !== '') as HTMLElement;
                    const firstErrorParent = firstError?.parentElement;
                    
                    if (navHeight && firstErrorParent) {
                        window.scrollTo({
                            behavior: 'smooth',
                            left: 0,
                            top: firstErrorParent.offsetTop - navHeight - 20,
                        });
                    }
                }
            });
        });
    }

    getStripeForm(api_public_key:string, amount?: number) {
        this.stripe = Stripe(api_public_key);
        const options = {
            wallets: 'never', // Pas de Apple Pay et de Google Pay
            layout: {
                type: 'accordion',
                defaultCollapsed: false,
                radios: true,
                spacedAccordionItems: false,
            }
        };
        
        this.stripePaymentElements = this.stripe.elements({
                mode: 'payment',
                currency: 'eur',
                amount: amount,
                payment_method_types:[ 'card' ],
            });

        const stripeForm = this.stripePaymentElements.create('payment', options);
        return stripeForm;
    }

    stripePayment(): void {
        // On génère une intention de paiement
        const stripe = this.stripe;
        const elements = this.stripePaymentElements;
        const formData = new URLSearchParams();
        const sectionPayment = document.querySelector('div[data-section="payment"]') as HTMLDivElement;
        const errorElement = sectionPayment.querySelector('.alert') as HTMLDivElement;
        const navHeight = document.getElementById('main-header')?.offsetHeight;
        const container = this.$container;

        formData.append('action', 'process_subscribe_form');
        
        for (const pair of new FormData(this.$container)) {
            formData.append(pair[0], pair[1] as string);
        }

        postData(script_var.ajax_url, formData).then(response => {
            if (response.success) {
                this.stripePaymentElements.submit()
                .then(function(result) {
                    if (!result.error) {
                        if (errorElement) {
                            errorElement.classList.add('hidden');
                            errorElement.classList.remove('error');
                            errorElement.innerHTML='';
                        }
                        
                        // Création de l'intention de paiement
                        stripe.confirmPayment({
                            elements,
                            clientSecret:response.data.payment_intent.client_secret,
                            confirmParams: {
                                return_url: [location.protocol, '//', location.host, location.pathname].join(''),
                                payment_method_data: {
                                    billing_details: response.data.billing_details,
                                },
                            },
                            redirect: 'if_required'
                        }).then(function(result) {
                            if (result.error) {
                                container.classList.remove('loading');
                                if (errorElement) {
                                    if (navHeight) {
                                        window.scrollTo({
                                            behavior: 'smooth',
                                            left: 0,
                                            top: sectionPayment.offsetTop - navHeight,
                                        });
                                    }

                                    errorElement.classList.add('error');
                                    errorElement.innerHTML=result.error.message;
                                    errorElement.classList.remove('hidden');
                                }
                            } else if (result.paymentIntent && 'succeeded' === result.paymentIntent.status) {
                                formData.append('form_subscribe[payment_intent]', result.paymentIntent.id);
                                formData.append('form_subscribe[payment_intent_client_secret]', result.paymentIntent.client_secret);
                                formData.append('form_subscribe[payment_intent_status]', result.paymentIntent.status);
                                formData.set('action', 'submit_subscribe_form');
                                
                                postData(script_var.ajax_url, formData).then(response => {
                                    if (response.success) {
                                        if (response.data.return_url) {
                                            location.href = response.data.return_url;
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
                
            }
        });

    }

    offlinePayment(): void {
        const formData = new URLSearchParams();
        formData.append('action', 'submit_subscribe_form');
        
        for (const pair of new FormData(this.$container)) {
            formData.append(pair[0], pair[1] as string);
        }

        postData(script_var.ajax_url, formData).then(response => {
            if (response.success) {
                if (response.data.return_url) {
                    location.href = response.data.return_url;
                }
            }
        });
    }

    updateCart(): void {
        type Line = { id?: number, name: string, price: number, count: number };
        const lines: Line[] = [];
        const $nbSubscriptions = this.$container.querySelectorAll('.js-form-row-new-subscription-fields.cloned').length + 1;
        
        // Suppression des anciennes lignes
        this.$cartLinesContainer.innerHTML = '';
        
        if (this.$amount) {
            lines.push({
                name: 'Abonnement',
                price: (this.$amount / 100),
                count: $nbSubscriptions,
            });

            // Ajout des nouvelles lignes
            const $lines: HTMLLIElement[] = [];
            lines.forEach(line => {
                const $nameDiv = document.createElement('div');
                $nameDiv.classList.add('article');
                $nameDiv.innerText = line.name + (line.count > 1 ? ' (x' + line.count + ')' : '');
        
                const $priceDiv = document.createElement('div');
                $priceDiv.classList.add('article-price');
                $priceDiv.innerText = (line.price * line.count).toString() + '€';
        
                const $li = document.createElement('li');
                $li.classList.add('line');
                $li.append($nameDiv, $priceDiv);
    
                $lines.push($li);
            });

            this.$cartLinesContainer.append(...$lines);

            // Modification du total
            this.total = lines.map(line => line.price * line.count).reduce((prev, current) => prev + current, 0);
            this.totalInCents = this.total*100;
            this.$cartTotalContainer.innerText = lines.map(line => line.price * line.count).reduce((prev, current) => prev + current, 0).toString() + '€';
            
            // Mise à jour du formulaire Stripe

            const formData = new URLSearchParams();
            formData.append('action', 'get_stripe_init_abonnement');
            postData(script_var.ajax_url, formData).then(response => {
                if (response.success) {
                    console.log(this.totalInCents);
                    const stripeForm = this.getStripeForm(response.data.stripe_api_public_key, this.totalInCents);
                    stripeForm.mount('#payment-element');
                }
            });
            
        }

    }

    displayError(fieldError: HTMLElement, errorMessage: string): void
    {
        const $errorContainer = fieldError;

        if ($errorContainer) {
            $errorContainer.innerText = errorMessage;
        }
    }

    resetErrors(): void {
        this.$container.querySelectorAll<HTMLElement>('.form-error[role="alert"]').forEach($errorContainer => $errorContainer.innerText = '');
    }
}
